// /app/frontend/src/components/InnerWorkCard.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, Sparkles } from "lucide-react";
import { getTodayPrompt } from "../api/innerWork";
import InnerWorkModal from "./InnerWorkModal";

export default function InnerWorkCard() {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [savedToast, setSavedToast] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const p = await getTodayPrompt();
        if (mounted) setPrompt(p);
      } catch {
        // silent fail; card still renders
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const onCreated = () => {
    setSavedToast("✓ Saved privately");
    setTimeout(() => setSavedToast(""), 3000);
  };

  return (
    <div className="rounded-2xl border border-slate-800 bg-gradient-to-br from-slate-900 to-slate-900/80 p-5 shadow-lg">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-500/20">
            <BookOpen className="w-5 h-5 text-purple-400" />
          </div>
          <div>
            <div className="text-base font-semibold text-white">Inner Work</div>
            <div className="text-xs text-slate-400">Reflection → clarity → better connection</div>
          </div>
        </div>
        <button
          type="button"
          className="rounded-xl border border-slate-700 px-3 py-1.5 text-xs text-slate-300 hover:bg-slate-800 transition"
          onClick={() => navigate("/inner-work")}
        >
          View all
        </button>
      </div>

      <div className="mt-4 rounded-xl bg-slate-800/50 border border-slate-700/50 p-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-3.5 h-3.5 text-amber-400" />
          <span className="text-[10px] uppercase tracking-wider text-slate-500">Today&apos;s Reflection</span>
        </div>
        <div className="mt-2 text-sm text-slate-200">
          {loading ? "Loading…" : (prompt?.prompt_text || "No topic today. You can still reflect.")}
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <button
          type="button"
          className="rounded-xl bg-purple-500 hover:bg-purple-600 px-5 py-2.5 text-sm font-medium text-white transition"
          onClick={() => setOpen(true)}
        >
          Reflect now
        </button>
        {savedToast ? (
          <div className="text-xs text-emerald-400 animate-pulse">{savedToast}</div>
        ) : null}
      </div>

      <InnerWorkModal
        open={open}
        onClose={() => setOpen(false)}
        prompt={prompt}
        onCreated={onCreated}
        title="Inner Work — Reflection"
      />
    </div>
  );
}
